export const black = "#000"
export const white = "#fff"
export const mhraBlue = "rgb(15, 18, 144)"
export const mhraBlue10 = "rgb(231, 235, 244)"
export const mhraBlue80 = "rgb(63, 65, 166)"
export const mhraBlue90 = "rgba(15, 18, 144, 0.9)"
export const mhraYellow = "rgb(252, 217, 0)"
export const mhraGray = "rgb(154, 155, 156)"
export const mhraGray30 = "rgba(154, 155, 156, 0.3)"

export const primaryColor = mhraBlue
export const anchorColour = "#1d70b8"

export const agency10 = "#e5f7f4"
export const agency20 = "#ccefe9"
export const agency30 = "#b3e6df"
export const agency40 = "#99ded4"
export const agency50 = "#80d6c9"
export const agency60 = "#66cebe"
export const agency70 = "#4dc6b3"
export const agency80 = "#33bda9"
export const agency90 = "#1ab59e"
export const mhra10 = "#e7ebf4"
export const mhra20 = "#cfd0e9"
export const mhra40 = "#9fa0d3"
export const mhra30 = "#b7b8de"
export const mhra50 = "#8788c7"
export const mhra70 = "#5759b1"
export const mhra60 = "#6f71bc"
export const mhra80 = "#3f41a6"
export const mhra90 = "#272a9b"
export const mhra = "#0f1290"
export const mhraGreen10 = "#f2f8e5"
export const mhraGreen20 = "#e4f1cc"
export const mhraGreen30 = "#d7eab3"
export const mhraGreen40 = "#cae399"
export const mhraGreen50 = "#bcdb80"
export const mhraGreen60 = "#afd466"
export const mhraGreen80 = "#95c633"
export const mhraGreen70 = "#a2cd4d"
export const mhraGreen90 = "#87bf1a"
export const mhraGreen = "#7ab800"
export const mhraWhite = "#ffffff"
export const mhraGray10 = "#f5f5f5"
export const mhraGray20 = "#ebebeb"
// export const mhraGray30 = '#e1e1e1';
export const mhraGray40 = "#d7d7d7"
export const mhraGray50 = "#cccdcd"
export const mhraGray60 = "#c2c3c4"
export const mhraGray70 = "#b8b9ba"
export const mhraGray80 = "#aeafb0"
export const mhraGray90 = "#a4a5a6"
export const mhraOrange10 = "#fdf3e5"
export const mhraOrange20 = "#fbe8cc"
export const mhraOrange30 = "#f8dcb3"
export const mhraOrange40 = "#f6d099"
export const mhraOrange50 = "#f4c480"
export const mhraOrange60 = "#f2b966"
export const mhraOrange70 = "#f0ad4d"
export const mhraOrange80 = "#eda133"
export const mhraOrange90 = "#eb961a"
export const mhraOrange = "#e98a00"
export const mhraPharma10 = "#f3e8ec"
export const mhraPharma20 = "#e8d1d9"
export const mhraPharma30 = "#dcbbc5"
export const mhraPharma40 = "#d1a4b2"
export const mhraPharma50 = "#c58d9f"
export const mhraPharma60 = "#b9768c"
export const mhraPharma70 = "#ae5f79"
export const mhraPharma80 = "#a24965"
export const mhraPharma90 = "#973252"
export const mhraPharma = "#8b1b3f"
export const mhraPurple10 = "#f4edf5"
export const mhraPurple20 = "#e9dcec"
export const mhraPurple30 = "#dfcbe2"
export const mhraPurple40 = "#d4b9d8"
export const mhraPurple50 = "#c9a7cf"
export const mhraPurple60 = "#be96c5"
export const mhraPurple70 = "#b385bb"
export const mhraPurple80 = "#a973b1"
export const mhraPurple90 = "#9e62a8"
export const mhraPurple = "#93509e"
export const mhraRed10 = "#f9e7ea"
export const mhraRed20 = "#f4ced6"
export const mhraRed30 = "#eeb6c1"
export const mhraRed40 = "#e89eac"
export const mhraRed50 = "#e38597"
export const mhraRed60 = "#dd6d83"
export const mhraRed70 = "#d7556e"
export const mhraRed80 = "#d13d59"
export const mhraRed90 = "#cc2445"
export const mhraRed = "#c60c30"
export const mhraYellow10 = "#fffbe5"
export const mhraYellow30 = "#fef4b3"
export const mhraYellow20 = "#fef7cc"
export const mhraYellow40 = "#fef099"
export const mhraYellow50 = "#fdec80"
export const mhraYellow60 = "#fde866"
export const mhraYellow70 = "#fde44d"
export const mhraYellow80 = "#fde133"
export const mhraYellow90 = "#fcdd1a"
export const mhratext = "#222526"
